import styled from 'styled-components';

import { COLORS } from 'constants/styles';

export const BorderStyled = styled.div`
  background-color: ${COLORS.GREY_G4};
  height: 1px;
  width: 100%;
`;
